import { render, staticRenderFns } from "./BlockData.vue?vue&type=template&id=595eb22d&"
import script from "./BlockData.vue?vue&type=script&lang=js&"
export * from "./BlockData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports